import React, {Component, useCallback} from 'react';

import {MenuItem, Tag} from "@blueprintjs/core";
import {Select, MultiSelect} from "@blueprintjs/select";
import toastr from 'toastr';

export default class TagsMultiselector extends Component {
    state = {
        createTag: '',
        newTagName: ''
    }

    multiMenuItem = (item, {modifiers, handleClick}) => {
        if (this.props.selectedTags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />
            )
        } else {
            return (
                <MenuItem
                    className='multiselect-menu-item'
                    icon='small-tick'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    shouldDismissPopover={true}
                />
            )
        }
    }

    handleTagRemove = async (item) => {
        let selectedTagsIds = [];
        // console.log('tag select item:', item);
        const selectedTags = this.props.selectedTags;


        // console.log('selected tags:', selectedTags);
        // console.log('item', item);
        // console.log('itemId:', item.key);

        const newTags = await selectedTags.filter(t => t.tag !== item.props.children);

        // newTags.map(tag => {
        //     selectedTagsIds = [...selectedTagsIds, tag.id]
        // });

        //console.log('newTags: ', newTags);
        // console.log('selectedTagsIds -  remove: ', selectedTagsIds);

        // await this.setState({selectedTags: newTags});

        this.props.updateTags(newTags)
        // this.props.updateTagsIds(selectedTagsIds)
    };

    tagSelect = async (item) => {
        let selectedTagsIds = await this.props.selectedTagsIds;
        //console.log('tag select item:', item);
        const selectedTags = await this.props.selectedTags;

        if (!selectedTags.includes(item)) {
            await selectedTags.push(item);
            // await this.setState({selectedTags});
            await this.props.updateTags(selectedTags)
        } else {
            // selectedTags.map(tag => console.log(tag.id !== item.id));
            const newTags = await selectedTags.filter(t => t.id !== item.id);
            // await this.setState({selectedTags: newTags})
            await this.props.updateTags(newTags)
        }

        // if (!selectedTagsIds.includes(item.id)) {
        //
        //     await selectedTagsIds.push(item.id);
        //     await this.setState({selectedTagsIds});
        // } else {
        //     const newTagsIds = await selectedTagsIds.filter(t => t !== item.id);
        //     selectedTagsIds = await [];
        //     await newTagsIds.map(tag=> {selectedTagsIds = [...selectedTagsIds, tag]})
        //     await this.setState({selectedTagsIds})
        // }

        // await this.state.selectedTags.map(tag => {
        //     selectedTagsIds = [...selectedTagsIds, tag.id]
        // });
        // await console.log('selected tags ids:', selectedTagsIds, selectedTags);

        // this.props.updateTagsIds(selectedTagsIds)

        // console.log('tags select end')

    };

    tagRender = (item) => {
        return (
            <Tag key={item.id}>{item.tag}</Tag>
        )
    };

    filterTags = (item) => {
        return this.props.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    }

    handleCreateAddTag = async (e) => {
        if (e === '' ) {
            toastr.error("Error Code #13009: Please add a tag name to create a tag!");
        } else {
            let tagExists = this.props.tags.filter(tag => tag === e);
            // console.log('tagExists let: ',);

            if (tagExists.length > 0) {
                toastr.error("Error Code #13010: This tag already exists! Please choose a different tag name.");

            } else {

                await this.props.handleCreateTag(e);
                if(!this.props.dontHandleGetTags){
                    await this.props.handleGetTags();
                    toastr.success("You have successfully created and assigned tag!");
                }
                //console.log('props tags:', this.props.tags);

            }
        }
    };

    renderCreateFilmOption = ( tag, active, handleClick ) => (
        <MenuItem
            icon="add"
            text={'Create New Tag'}
            active={active}
            onClick={() => this.handleCreateAddTag(this.state.newTagName)}
            shouldDismissPopover={false}
        />
    );

    createFilm = (tag) => {
        this.setState({newTagName: tag})
    }

    render(){

        return(
            <div style={{width: this.props.width || 'auto'}}>
                {/*{console.log('selectedTags: ', this.props.selectedTags, this.props.selectedTagsIds)}*/}
                <MultiSelect
                    items={this.props.tags}
                    itemRenderer={this.multiMenuItem}
                    tagInputProps={{
                        placeholder: 'Select or create new tags',
                        onRemove: this.handleTagRemove
                    }}
                    //resetOnSelect={true}
                    className={this.props.squareType ? 'tag-multiselect-square' : 'tag-multiselect' }
                    onItemSelect={this.tagSelect}
                    tagRenderer={this.tagRender}
                    itemListPredicate={this.filterTags}
                    selectedItems={this.props.selectedTags}
                    createNewItemFromQuery={ this.createFilm }
                    createNewItemRenderer={ this.renderCreateFilmOption }
                    fill={true}
                    noResults={<MenuItem disabled={true} text="No results."/>}
                />
            </div>
        )
    }
}